import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import teceoSelectConfig from '../../utils/TeceoSelectConfig';
import Select, { SelectProps } from '../FormInputs/Select/Select';

type SelectFieldProps = Pick<
  SelectProps,
  'label' | 'items' | 'disabled' | 'fullWidth' | 'variant' | 'size'
>;
type Props<TForm extends FieldValues> = {
  control: Control<TForm>;
  name: Path<TForm>;
  helperTextKey?: string;
  variant?: 'standard' | 'outlined' | 'filled';
  onChange?: (value: unknown) => void;
} & SelectFieldProps;

export function RHFSelect<TForm extends FieldValues>({
  control,
  name,
  label,
  items,
  disabled,
  helperTextKey,
  fullWidth = true,
  variant = 'outlined',
  size,
  onChange,
}: Props<TForm>) {
  const sizeOverride = size ? { size, margin: 'none' as const, formControlProps: { size } } : {};

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <Select
          {...teceoSelectConfig}
          {...sizeOverride}
          {...field}
          onChange={(event) => {
            field.onChange(event);
            if (onChange) {
              onChange(event.target.value);
            }
          }}
          helperText={helperTextKey ?? fieldState.error?.message ?? undefined}
          label={label}
          error={!!fieldState.error}
          value={field.value ?? ''}
          fullWidth={fullWidth}
          disabled={disabled}
          variant={variant}
          items={items}
        />
      )}
    />
  );
}
